import styles from "./noMessage.module.scss";
import nodraft from "../../../../styles/images/empty_states/empty-draft.svg";
import { URButton } from "../../../../shared/widgets/button";
import React from "react";
import { DraftService } from "../../../../base/draftService";
import { useHistory } from "react-router-dom";
type NoMessageProps = {
  setFilteredLayer: ()=> void;
}
export default function NoMessage({setFilteredLayer}:NoMessageProps) {
  const history = useHistory();
  return (
    <>
      <div className={styles.noMessage}>
        <div className={styles.noMessageinner}>
          <img src={nodraft} alt="" />
          <p className={styles.noMessageTitle}>Draft Messages</p>
          <p className={styles.noMessageDesc}>
          Here you ll find any message that you started typing but
          did not send. You can read, edit, revise, and send anytime you like. Delete the drafts that you don t need.
          </p>
          <URButton className='urButton btnew buttonSm' name='New Message'
            onClick={()=>DraftService.openChatNewNessage(history)}/>
          <div className={styles.recentBtn} onClick={()=>setFilteredLayer()}>
            <span className="icon_outlineleftarrow"></span>
            <span>Recent</span>
          </div>
        </div>
      </div>
    </>
  );
};

